import { Stack, Typography } from "@mui/material";
import {
  StyledLinkApplicationBackButtonBox,
  StyledLinkApplicationSubTextBox,
} from "../../../Styles/LinkApplication/LinkMyApplication";
import { BackButton, CheckCircleIcon } from "react-common-ui-library";
import { useIntl } from "react-intl";
import {
  BACK_BUTTON_TEXT,
  H1,
  H3,
  LINK_APPLICATION_ROUTE,
  P_REGULAR,
  SEARCH_HAP_ID_ROUTE,
  SECONDARY_MAIN,
} from "../../../Constants/CommonConstants";
import { useNavigate } from "react-router-dom";
import ResultsHapCard from "./ResultsHapCard";
import { manageLinkApplicationSelector } from "../../../Selectors/LinkApplicationSelector";
import { useSelector } from "react-redux";
import {
  LINK_RESULTS_TEXT,
  LINK_APPLICATION_CHECK_ICON_ID,
  LINK_APPLICATION_HEADING,
  LINK_APPLICATION_RESULTS_BACK_BUTTON,
} from "../../../Constants/LinkMyApplicationConstants";

/**
 * @description Link Application Results screen allows the user view search results and display user name and hapId details
 * @returns {ReactNode} Renders the Link Application Results Screen which has the heading, subtext and ResultsHapCard component
 */
export const LinkApplicationResults = () => {
  const intl = useIntl();

  const navigate = useNavigate();

  const { hapIdDataHapId } = useSelector((state) =>
    manageLinkApplicationSelector(state),
  );
 

  const onBackClickHandler = () => {
    !hapIdDataHapId
      ? navigate(`/${LINK_APPLICATION_ROUTE}/${SEARCH_HAP_ID_ROUTE}`)
      : navigate(`/${LINK_APPLICATION_ROUTE}`);
  };

  return (
    <Stack spacing={{ xs: 3, md: 5 }}>
      <StyledLinkApplicationBackButtonBox>
        <BackButton
          id={LINK_APPLICATION_RESULTS_BACK_BUTTON}
          backButtonText={intl.formatMessage({ id: BACK_BUTTON_TEXT })}
          backButtonOnClickHandler={onBackClickHandler}
        />
      </StyledLinkApplicationBackButtonBox>
      <Stack spacing={{ xs: 2.5, md: 2 }}>
        <Typography
          component={H1}
          variant={H3}
          color={SECONDARY_MAIN}
          id={LINK_APPLICATION_HEADING}
        >
          {intl.formatMessage({ id: LINK_APPLICATION_HEADING })}
        </Typography>
        <StyledLinkApplicationSubTextBox>
          <CheckCircleIcon id={LINK_APPLICATION_CHECK_ICON_ID} />
          <Typography variant={P_REGULAR} id={LINK_RESULTS_TEXT}>
            {intl.formatMessage({ id: LINK_RESULTS_TEXT })}
          </Typography>
        </StyledLinkApplicationSubTextBox>
      </Stack>
      <ResultsHapCard />
    </Stack>
  );
};

export default LinkApplicationResults;
